import React from 'react';
import { useSelector } from 'react-redux';

const AddBtn = () => {
    
    const auth = useSelector((state) => state.auth);
    let role = auth.user.role;

    if(auth.user && !auth.loading ){
        return (
            <div className='fixed-action-btn'>
                <a href='#add-log-modal' className="btn-floating btn-large blue darken-2 modal-trigger"><i className="large material-icons">add</i></a>
                <ul>
                    <li>
                        <a href='#tech-list-modal' className='btn-floating green modal-trigger'>
                            <i className='material-icons'>person</i>
                        </a>
                    </li>
                    {(role === 'Admin') ? (<li>
                        <a href='#add-user-modal' className='btn-floating red modal-trigger'>
                            <i className='material-icons'>person_add</i>
                        </a>
                    </li>) : <span></span>}
                    
                </ul>
            </div>
        )
    }
  
}

export default AddBtn